/**
 * SECTION - NAVIGATION SIDEBAR - LISTENERS
 */

setupEventListenersForNavigationSidebar();

// Creates the event listeners
function setupEventListenersForNavigationSidebar() {
  // On clicking on the open or close button of the side menu
  document.querySelectorAll('[data-action="open-navigation-sidebar"], [data-action="close-navigation-sidebar"]').forEach((element) => {
    element.addEventListener('click', toggleNavigationSidebarHandler);
  });
  
  // On clicking on a collapsible dropdown menu item
  document.querySelectorAll('.navigation-sidebar__dropdowns .navigation-sidebar__item--expandable > .navigation-sidebar__link').forEach((element) => {
    element.addEventListener('click', clickMenuMobileDropdownItemHandler);
  });
  
  // On clicking on a collapsible list menu item
  document.querySelectorAll('.navigation-sidebar__lists .navigation-sidebar__item--expandable > .navigation-sidebar__link').forEach((element) => {
    element.addEventListener('click', clickMenuMobileListItemHandler);
  });
  
  // On clicking on the "Back" button of a fold-out menu item of a list
  document.querySelectorAll('[data-action="rewind-navigation-sidebar"]').forEach((element) => {
    element.addEventListener('click', clickMenuMobileRewindListItemHandler);
  });
}

/**
 * SECTION - NAVIGATION SIDEBAR - GENERAL
 */

// On clicking on the open or close button of the side menu
function toggleNavigationSidebarHandler() {
  event.preventDefault();
  toggleSidebar('navigation');
}

// On clicking on a collapsible dropdown menu item
function clickMenuMobileDropdownItemHandler() {
  event.preventDefault();
  openNextDropdown();
}

// On clicking on a collapsible list menu item
function clickMenuMobileListItemHandler() {
  event.preventDefault();
  openNextLevel();
}

// On clicking on the "Back" button of a fold-out menu item of a list
function clickMenuMobileRewindListItemHandler() {
  event.preventDefault();
  rewindNavigationSidebar();
}

// Opens the mobile menu dropdown
function openNextDropdown() {
  var target = event.currentTarget,
      itemMenu = target.closest('.navigation-sidebar__item'),
      itemMenuSiblings = getSiblings(itemMenu);

  itemMenu.classList.toggle('navigation-sidebar__item--active');
  itemMenu.setAttribute('aria-expanded', itemMenu.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
  itemMenuSiblings.forEach((element) => {
    var navigationSidebarItemActive = element.querySelector('.navigation-sidebar__item--active');
    
    element.classList.remove('navigation-sidebar__item--active');
    element.setAttribute('aria-expanded', 'false');
    
    if (navigationSidebarItemActive !== null) {
      navigationSidebarItemActive.classList.remove('navigation-sidebar__item--active');
      navigationSidebarItemActive.setAttribute('aria-expanded', 'false');
    }
  });
  
  document.addEventListener('click', () => {
    if (event.target.closest('.navigation-sidebar__dropdowns') === null) {
      var navigationSidebarItemActive = itemMenu.querySelector('.navigation-sidebar__item--active');
      
      itemMenu.classList.remove('navigation-sidebar__item--active');
      itemMenu.setAttribute('aria-expanded', 'false');

      if (navigationSidebarItemActive !== null) {
        navigationSidebarItemActive.classList.remove('navigation-sidebar__item--active');
        navigationSidebarItemActive.setAttribute('aria-expanded', 'false');
      }
    }
  });

  return false;
};

// Opens the mobile menu list
function openNextLevel() {
  var target = event.currentTarget,
      navigationSidebar = document.querySelector('.section__page.navigation-sidebar'),
      navigationSidebarCurrent = navigationSidebar.querySelector('.sidebar__current-title'),
      currentLevel = target.closest('.navigation-sidebar__list'),
      subNav = target.getAttribute('data-open-nav'),
      nextLevel = navigationSidebar.querySelector('[data-nav-for="' + subNav + '"]');

  nextLevel.classList.add('navigation-sidebar__list--active');
  currentLevel.classList.add('navigation-sidebar__list--hidden');

  document.querySelector('[data-action="close-navigation-sidebar"]').style.display = 'none';
  document.querySelector('[data-action="rewind-navigation-sidebar"]').style.display = 'block';

  currentLevel = nextLevel;
  navigationSidebarCurrent.textContent = nextLevel.getAttribute('data-nav-name');

  return false;
};

// Returns to the parent level of the mobile menu
function rewindNavigationSidebar() {
  var navigationSidebar = document.querySelector('.section__page.navigation-sidebar'),
      navigationSidebarCurrent = navigationSidebar.querySelector('.sidebar__current-title'),
      currentLevel = navigationSidebar.querySelector('.navigation-sidebar__list.navigation-sidebar__list--active:not(.navigation-sidebar__list--hidden)'),
      parentLevel = navigationSidebar.querySelector('[data-nav-for="' + currentLevel.getAttribute('data-parent-nav') + '"]');

  currentLevel.classList.remove('navigation-sidebar__list--active');
  parentLevel.classList.remove('navigation-sidebar__list--hidden');

  // If the parent level has no parent, it means that we are back to the first
  if (!parentLevel.getAttribute('data-parent-nav')) {
    document.querySelector('[data-action="close-navigation-sidebar"]').style.display = 'block';
    document.querySelector('[data-action="rewind-navigation-sidebar"]').style.display = 'none';
    navigationSidebarCurrent.textContent = '';
  } else {
    navigationSidebarCurrent.textContent = parentLevel.getAttribute('data-nav-name');
  }

  currentLevel = parentLevel;

  return false;
};